import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { useConfig } from 'contexts/ConfigContext';

const containerStyle = {
    width: '100%',
    height: '300px'
};

export function Map({ data }) {
    const { configData } = useConfig();
    const { latitude, longitude } = data;

    const center = {
        lat: latitude,
        lng: longitude
    };

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: configData.googleApiKey
    });

    const mapOptions = {
        disableDefaultUI: true, 
        gestureHandling: 'none'  
    };


    if (!isLoaded) {
        return <div>Cargando mapa...</div>;
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
            options={mapOptions}
        >
            <Marker position={center} />

        </GoogleMap>
    );
};

